import { useEffect, useState } from 'react';
import TDisk from '../../templates/disk';
import quotaRequest from '../../../../shared/api/quota/request';

function Disk() {
  const [quota, setQuota] = useState(0);
  const [used, setUsed] = useState(0);
  const [days, setDays] = useState('  ');
  useEffect(() => {
    quotaRequest().then((data) => {
      setQuota(data.quota);
      setUsed(data.used);
      setDays(data.availableRecordingsDays + '');
    });
  });
  return <TDisk days={days} used={used} quota={quota}></TDisk>;
}

export default Disk;
